import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromMeteringPointStore from '@appStore/metering-points';
import { MeteringPoint } from '@model';
import * as fromStore from '@appStore/metering-points';
import { SubSink } from 'subsink';
import dayjs from 'dayjs';
import { DisturbanceType } from '@enums';
import { DisruptionInfo } from 'app/models/disruptionInfo.model';
@Component({
    selector: 'app-disruptions-pane',
    templateUrl: './disruptions-pane.component.html',
    standalone: false
})
export class DisruptionsPaneComponent implements OnInit, OnDestroy {
  displayDeliveryDisruptions: boolean = false;
  displayPlanneDisruptions: boolean = false;
  displayUnplannedDisruptions: boolean = false;
  displayRestoredDisruptions: boolean = false;
  constructor(private meteringStore: Store<fromStore.State>) {}

  isStartPageView: boolean = false;
  @Input()
  currentMeteringPoint: MeteringPoint;
  disruptions$: Observable<MeteringPoint[]>;
  plannedDisruptions = 0;
  unPlannedDisruptions = 0;
  deliveryDisruptions = 0;
  restoredDisruptions = 0;
  restoreTimeFormated: string;

  isLoading = true;
  selectedMeteringPoint: MeteringPoint;
  selectedMeteringPointDisruption: DisruptionInfo;
  selectedMeteringPointRestoredDisruption: DisruptionInfo;
  disturbanceTypeEnum = DisturbanceType;
  sxFakeDate= null;
  displayFakeDate=false;

  private subs = new SubSink();

  ngOnInit() {

    if(localStorage.getItem('sxFakeDate')){
      this.sxFakeDate = new Date(localStorage.getItem('sxFakeDate'));  
      this.displayFakeDate =true;
    }    
    if (!this.currentMeteringPoint){
      this.isStartPageView = true;
    }
    
    this.subs.sink = this.meteringStore
      .select(fromMeteringPointStore.getMeteringPointsWithDisruptions)
      .subscribe(mps => this.disruptionsLoaded(mps));
  }

  disruptionsLoaded = (disruptions: MeteringPoint[]) => {
    this.plannedDisruptions = 0;
    this.unPlannedDisruptions = 0;
    this.deliveryDisruptions = 0;
    this.restoredDisruptions = 0;
    
    let filteredMeteringPoints = this.isStartPageView ? disruptions : disruptions.filter(mp => mp.id === this.currentMeteringPoint.id);

    let filteredDisruptions: DisruptionInfo[] = new Array<DisruptionInfo>();

    filteredMeteringPoints.forEach(d => {
      if (d.disruptionInfos && d.disruptionInfos.length > 0){
        filteredDisruptions = [...filteredDisruptions, ...d.disruptionInfos];
        
        if(this.isStartPageView){
          let restoredDisruptions = d.disruptionInfos.filter(d => d.isRestored);
          let ongoingDisruptions = d.disruptionInfos.filter(d => !d.isRestored);

          if (ongoingDisruptions && ongoingDisruptions.length > 0){
            if (ongoingDisruptions.some(d => d.disturbanceType === DisturbanceType.Delivery)){
              this.deliveryDisruptions++;
            }
            else{
              if (ongoingDisruptions.some(d => d.isPlanned)){
                this.plannedDisruptions++;
              } else{
                this.unPlannedDisruptions++;
              }
            }
          }
          else {
            if (restoredDisruptions && restoredDisruptions.length > 0){
              this.restoredDisruptions++;
            }
          }
        }
      }
    });

    // Bugfix meteringPoint.disruptionsInfo not set when disruptions finally Loaded
    if (!this.isStartPageView) {
      if(filteredMeteringPoints && filteredMeteringPoints.length > 0){
        this.selectedMeteringPoint = filteredMeteringPoints[0];
       
        if (this.selectedMeteringPoint.disruptionInfos)
        {
          this.displayDeliveryDisruptions = this.selectedMeteringPoint.disruptionInfos.some(d => !d.isRestored && d.disturbanceType === DisturbanceType.Delivery);
          this.displayPlanneDisruptions = this.selectedMeteringPoint.disruptionInfos.some(d => !d.isRestored && d.disturbanceType === DisturbanceType.Planned);
          this.displayUnplannedDisruptions = this.selectedMeteringPoint.disruptionInfos.some(d => !d.isRestored && d.disturbanceType === DisturbanceType.Unplanned) || this.selectedMeteringPoint.disruptionInfos.some(d => !d.isRestored && d.disturbanceType === DisturbanceType.Unknown);
          
          if (this.displayPlanneDisruptions || this.displayUnplannedDisruptions || this.displayDeliveryDisruptions){
            this.selectedMeteringPointDisruption = this.selectedMeteringPoint.disruptionInfos.find(d => !d.isRestored);
            this.restoreTimeFormated = dayjs(this.selectedMeteringPointDisruption.estimatedRestoreTime).format('YYYY-MM-DD HH:mm');
          }
  
          this.displayRestoredDisruptions = this.selectedMeteringPoint.disruptionInfos.some(d => d.isRestored); 
          if (this.displayRestoredDisruptions){
            this.selectedMeteringPointRestoredDisruption = this.selectedMeteringPoint.disruptionInfos.find(d => d.isRestored);
          }
        }
      }
    }
    else{
      // startpage mode
      this.displayDeliveryDisruptions= this.deliveryDisruptions !== 0;
      this.displayPlanneDisruptions = this.plannedDisruptions !== 0;
      this.displayUnplannedDisruptions = this.unPlannedDisruptions !== 0;
      this.displayRestoredDisruptions = this.restoredDisruptions !== 0;
    }
    this.isLoading = false;
  };

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
